export default function HardwareBrands() {
  const brands = [
    {
      name: 'Ferco',
      specialty: 'Crémones et serrures',
      icon: 'ri-lock-2-line',
      features: ['Sécurité renforcée', 'Durabilité garantie'],
    },
    {
      name: 'Roto',
      specialty: 'Systèmes oscillo-battants',
      icon: 'ri-window-line',
      features: ['Innovation allemande', 'Qualité premium'],
    },
    {
      name: 'GU',
      specialty: 'Ferrures multipoints',
      icon: 'ri-shield-check-line',
      features: ['Protection maximale', 'Fiabilité éprouvée'],
    },
    {
      name: 'Siegenia',
      specialty: 'Quincaillerie premium',
      icon: 'ri-star-line',
      features: ['Excellence européenne', 'Design moderne'],
    },
    {
      name: 'Winkhaus',
      specialty: 'Systèmes de sécurité',
      icon: 'ri-shield-star-line',
      features: ['Anti-effraction', 'Technologie avancée'],
    },
    {
      name: 'Maco',
      specialty: 'Ferrures innovantes',
      icon: 'ri-lightbulb-line',
      features: ['Innovation constante', 'Performance optimale'],
    },
  ];

  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 hidden md:block">
      {/* Effets de fond animés */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* En-tête */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-2 bg-blue-500/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6 border border-blue-400/30">
            <i className="ri-award-line text-amber-400 text-xl"></i>
            <span className="text-blue-200 font-semibold text-sm uppercase tracking-wider">
              Partenaires Certifiés
            </span>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
            Marques de Quincaillerie
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-amber-400 mt-3">
              Leaders Européens
            </span>
          </h2>
          
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Nous collaborons exclusivement avec les fabricants les plus prestigieux pour garantir qualité, sécurité et longévité
          </p>
        </div>

        {/* Grille de marques - Design moderne */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-blue-400/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/20"
            >
              {/* Badge numéro */}
              <div className="absolute top-4 right-4 w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                {index + 1}
              </div>

              {/* Icône */}
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 via-cyan-500 to-amber-400 rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300">
                <i className={`${brand.icon} text-4xl text-white`}></i>
              </div>

              {/* Nom de la marque */}
              <h3 className="text-3xl font-extrabold text-white mb-2 group-hover:text-blue-300 transition-colors">
                {brand.name}
              </h3>

              {/* Spécialité */}
              <p className="text-blue-200 font-medium mb-6 text-lg">
                {brand.specialty}
              </p>

              {/* Caractéristiques */}
              <div className="space-y-3">
                {brand.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                    <span className="text-blue-100 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              {/* Badge certifié */}
              <div className="mt-6 pt-6 border-t border-white/10 flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <i className="ri-verified-badge-fill text-amber-400 text-xl"></i>
                  <span className="text-blue-200 text-sm font-semibold">Certifié CE</span>
                </div>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-line text-blue-300 text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Section garanties - Design moderne */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 shadow-xl">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-fill text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Pièces Certifiées</h3>
            <p className="text-blue-100 leading-relaxed">
              Garantie constructeur sur toutes les pièces installées
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 shadow-xl">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-box-3-fill text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Stock Permanent</h3>
            <p className="text-amber-50 leading-relaxed">
              Disponibilité immédiate des pièces courantes
            </p>
          </div>

          <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 shadow-xl">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-fill text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Garantie 2 ans</h3>
            <p className="text-cyan-50 leading-relaxed">
              Sur toutes nos interventions et pièces détachées
            </p>
          </div>
        </div>

        {/* Statistiques */}
        <div className="mt-16 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 backdrop-blur-lg rounded-3xl p-10 border border-blue-400/30">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 mb-2">
                6
              </div>
              <div className="text-blue-200 font-medium">Marques Premium</div>
            </div>
            <div>
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-amber-400 mb-2">
                100%
              </div>
              <div className="text-blue-200 font-medium">Pièces d'Origine</div>
            </div>
            <div>
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-blue-400 mb-2">
                2 ans
              </div>
              <div className="text-blue-200 font-medium">Garantie Totale</div>
            </div>
            <div>
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 mb-2">
                24h
              </div>
              <div className="text-blue-200 font-medium">Délai Moyen</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
